<template>
    <div class="customRadio">
        <input
            type="radio"
            v-model="myValue"
            :id="id"
            :name="name"
            :value="valueAttr"
            @change="handleChange"
        >
        <label :for="id"></label>
        <div class="customRadioLabel" v-text="label" />
    </div>
</template>

<script>
export default {
    props: [
        'name',
        'value',
        'id',
        'label',
        'valueAttr',
    ],
    data() {
        return {
            myValue: this.value,
        };
    },
    watch: {
        value() {
            this.myValue = this.value;
        },
    },
    methods: {
        handleChange() {
            this.$emit('input', this.myValue);
        },
    },
}
</script>

<style lang="scss">
.customRadio {
}
</style>
